import React from 'react';

import {IconoirHelpCircle} from '@ey-xd/motif-icon';
import NavLink from './NavLink';

export default (label, url) => ({
	id: 2,
	key: 2,
	url: 2, // CCS TopNav component sets link.url as the key for links this is set up to supress that warning on the console
	className: 'helpIcon',
	isLink: false,
	children: <NavLink {...{label, url, icon: IconoirHelpCircle, outsideNavigation: true}} />
});
